import React from 'react';

import {
  Card as MuiCard,
  CardContent,
  CardHeader,
  styled
} from '@mui/material';



const Card = styled(MuiCard)(() => ({
  borderRadius: '25px',
  flex: 1,
  height: '100%'
}));



export interface IProps {
  title?: string;
  children?: React.ReactNode | React.ReactNode[];
  elAction?: React.ReactNode;
}

export const FC: React.FC<IProps> = props => {
  return (
    <Card>
      {(props.title || props.elAction) && (
        <CardHeader
          title={props.title}
          action={props.elAction} />
      )}

      <CardContent>
        {props.children}
      </CardContent>
    </Card>
  );
};
